import { Routes } from "@angular/router";
import { LoginGuard } from "../../shared/authguards/login.guard";
import { authenticatedPlatformRedirectGuard } from "../../shared/authguards/authenticated-platform-redirect.guard";

export const BEFORE_LOGIN_ROUTES: Routes = [
  {
    path: "",
    loadComponent: () => import("./before-login.component").then(m => m.BeforeLoginComponent),
    data: { title: "pageTitles.welcome" },
    canActivate: [LoginGuard, authenticatedPlatformRedirectGuard],
    children: [
      {
        path: "welcome",
        loadComponent: () => import("./landing-page/landing-page.component").then(m => m.LandingPageComponent),
        data: { title: "pageTitles.welcome" },
      },
      {
        path: "paid-services",
        loadComponent: () => import("./paid-services-landing/paid-services-landing.component").then(m => m.PaidServicesLandingComponent),
        data: { title: "pageTitles.premiumPage" },
      },
      {
        path: "paid-services/weight-info",
        loadComponent: () => import("../paid-services/weight-info/weight-info").then(m => m.WeightInfo),
        data: { title: "pageTitles.weightInfo", publicArticle: true },
      },
    ],
  },
];
